import { z } from "zod";
export const companyRegistrationSchema = z.object({
    companyName: z.string().trim().min(2).max(200),
    website: z.url().max(300).optional().or(z.literal("")),
    contactName: z.string().trim().min(1).max(150),
    contactEmail: z.email().max(320),
    contactPhone: z.string().trim().max(30).optional().or(z.literal("")),
    answers: z.record(z.string(), z.unknown()).default({}),
});
/** Industry-facing internship posting. Extra form fields land in `answers`. */
export const positionSchema = z.object({
    title: z.string().trim().min(2).max(200),
    description: z.string().trim().min(10).max(20000),
    location: z.string().trim().max(200).optional().or(z.literal("")),
    paid: z.boolean().default(true),
    hoursPerWeek: z.coerce.number().int().min(1).max(60).optional(),
    startDate: z.string().trim().max(20).optional().or(z.literal("")),
    endDate: z.string().trim().max(20).optional().or(z.literal("")),
    closesAt: z.iso.datetime().optional(),
    answers: z.record(z.string(), z.unknown()).default({}),
});
export const POSITION_STATUSES = ["DRAFT", "PENDING_APPROVAL", "PUBLISHED", "CLOSED"];
export const COMPANY_STATUSES = ["PENDING_APPROVAL", "APPROVED", "REJECTED", "SUSPENDED"];
export const magicLinkRequestSchema = z.object({
    email: z.email().max(320),
});
